import { FETCH_CLUB, FETCH_CLUB_SUCCESS, FETCH_CLUB_FAILURE, SAVE_CLUB_SUCCESS, SAVE_CLUB_FAILURE,
  CLUB_AJAX_CALL, CLUB_CLEAR_AJAX_CALL, UPLOAD_SIGNATURE_STARTED, UPLOAD_SIGNATURE_SUCCESS, UPLOAD_SIGNATURE_FAILURE } from '../actions/Club'

const initialState = {
  info: null,
  error: null,
  loading: false,
  ajaxSpinner: false,
  ajaxStatus: null
}

export default function club (state = initialState, action) {
  switch (action.type) {
    case FETCH_CLUB:
      return {...state, loading: true, error: null, info: null}
    case FETCH_CLUB_SUCCESS:
      return {...state, info: action.payload, loading: false, error: null}
    case FETCH_CLUB_FAILURE:
      return {...state, error: action.payload, loading: false, info: null}
    case SAVE_CLUB_SUCCESS:
      return {...state, info: action.payload, ajaxStatus: null, ajaxSpinner: false}
    case SAVE_CLUB_FAILURE:
      return {...state, ajaxStatus: action.payload, ajaxSpinner: false}
    case CLUB_AJAX_CALL:
      return {...state, ajaxSpinner: true, ajaxStatus: null}
    case CLUB_CLEAR_AJAX_CALL:
      return {...state, ajaxSpinner: false, ajaxStatus: null}
    case UPLOAD_SIGNATURE_STARTED:
      return {...state, ajaxSpinner: true, ajaxStatus: null}
    case UPLOAD_SIGNATURE_SUCCESS:
      return {...state, info: action.payload, ajaxStatus: null, ajaxSpinner: false}
    case UPLOAD_SIGNATURE_FAILURE:
      return {...state, ajaxStatus: null, ajaxSpinner: false}
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/club.js